import store from '@/store';
import Vue from 'vue';
import Trimaster from '@/plugins/servers/trimaster';
const state = {
  preferences: [],
};

const getters = {
  preferences: (state) => state.preferences,
  preferenceSetting: (state) => (preferenceName) => {
    let preference = state.preferences.find((preference) => preference.preferenceName === preferenceName);
    return preference ? preference.setting : null;
  },
};

const actions = {
  async load({ commit }) {
    let [res, err] = await Trimaster.get('facilityFrontendPreferences/load', store.getters['getUser'].apitoken, {
      facility_id: store.getters['getUser'].facility_id,
    });
    if (res && res.success) {
      commit('setPreferences', res.data);
    }
  },
  async updatePreference({ commit }, preference) {
    commit('setPreference', preference);
  },
};

const mutations = {
  setPreferences(state, preferences) {
    state.preferences = preferences;
  },
  setPreference(state, preference) {
    state.preferences = state.preferences.map((eachPreference) => {
      if (eachPreference.id === preference.id) {
        return preference;
      } else {
        return eachPreference;
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
